var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Publisher'
      }],
      "title": "All Publisher"
    }
  }), _c('div', {
    staticClass: "flex-col w-full bg-white rounded-lg"
  }, [_c('div', {
    staticClass: "flex items-center justify-between w-full px-4 py-3 mt-3 rounded-lg"
  }, [_c('div', {
    staticClass: "relative w-2/6"
  }, [_c('SearchOutline', {
    attrs: {
      "className": "text-xl absolute top-1/2 left-3 transform -translate-y-1/2"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query_search,
      expression: "query_search"
    }],
    staticClass: "p-2.5 pl-5 w-full text-sm border rounded-md bg-gray-50",
    attrs: {
      "type": "search",
      "placeholder": "Search Publisher Name, Publisher ID AX"
    },
    domProps: {
      "value": _vm.query_search
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch.apply(null, arguments);
      },
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.query_search = $event.target.value;
      }, _vm.onSearch]
    }
  })], 1), _c('div', {
    staticClass: "relative flex justify-end w-3/4"
  }, [_c('Button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "default",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/vendor/create');
      }
    },
    scopedSlots: _vm._u([{
      key: "iconBefore",
      fn: function () {
        return [_c('i', {
          staticClass: "fa fa-plus"
        })];
      },
      proxy: true
    }])
  }, [_vm._v(" Add New ")]), _c('Button', {
    staticClass: "relative",
    attrs: {
      "variant": "outlined",
      "color": "alternative"
    },
    on: {
      "click": _vm.toggleDropdown
    },
    scopedSlots: _vm._u([{
      key: "iconBefore",
      fn: function () {
        return [_c('FilterFilled', {
          attrs: {
            "className": "h-3 w-3 text-gray-800"
          }
        })];
      },
      proxy: true
    }, {
      key: "iconAfter",
      fn: function () {
        return [_c('ChevronDownFilled', {
          attrs: {
            "className": "h-3 w-3 text-gray-500"
          }
        })];
      },
      proxy: true
    }])
  }, [_vm._v(" Filter "), _vm.activeFilterCount > 0 ? _c('span', {
    staticClass: "absolute flex items-center justify-center w-5 h-5 text-xs text-white bg-red-500 rounded-full -top-2 -right-2"
  }, [_vm._v(" " + _vm._s(_vm.activeFilterCount) + " ")]) : _vm._e()]), _c('VendorFilter', {
    attrs: {
      "isDropdownVisible": _vm.isDropdownVisible,
      "initialFilters": _vm.appliedFilters
    },
    on: {
      "update:isDropdownVisible": function ($event) {
        _vm.isDropdownVisible = $event;
      },
      "update:is-dropdown-visible": function ($event) {
        _vm.isDropdownVisible = $event;
      },
      "input": _vm.handleFilterInput,
      "reset": _vm.handleResetFilter
    }
  })], 1)])]), _c('Table', {
    attrs: {
      "headers": _vm.tableHeaders,
      "data": _vm.vendors,
      "rowKey": _vm.tableRowKeys,
      "currentPage": _vm.currentPage,
      "perPage": _vm.tablePerPage,
      "isLoading": _vm.isLoading,
      "withScrollX": true,
      "className": "mb-2 w-full"
    },
    on: {
      "sort": _vm.handleTableSort
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function (_ref) {
        var value = _ref.value,
          row = _ref.row;
        return [_c('router-link', {
          attrs: {
            "to": ("/vendor/detail/" + (row === null || row === void 0 ? void 0 : row.id))
          }
        }, [_vm._v(" " + _vm._s(value !== null && value !== void 0 ? value : '-') + " ")])];
      }
    }, {
      key: "sync_vendor",
      fn: function (_ref2) {
        var _value$vendor_id_ax;
        var value = _ref2.value;
        return [_vm._v(" " + _vm._s((_value$vendor_id_ax = value === null || value === void 0 ? void 0 : value.vendor_id_ax) !== null && _value$vendor_id_ax !== void 0 ? _value$vendor_id_ax : '-') + " ")];
      }
    }, {
      key: "cas_organization",
      fn: function (_ref3) {
        var _value$name;
        var value = _ref3.value;
        return [_vm._v(" " + _vm._s((_value$name = value === null || value === void 0 ? void 0 : value.name) !== null && _value$name !== void 0 ? _value$name : '-') + " ")];
      }
    }, {
      key: "vendor_type",
      fn: function (_ref4) {
        var row = _ref4.row;
        return [_vm._v(" " + _vm._s(row.is_external ? 'External' : 'Internal') + " ")];
      }
    }, {
      key: "status",
      fn: function (_ref5) {
        var row = _ref5.row;
        return [_c('div', [_c('Label', {
          attrs: {
            "variant": row !== null && row !== void 0 && row.is_active ? 'green' : 'gray'
          }
        }, [_vm._v(" " + _vm._s(row !== null && row !== void 0 && row.is_active ? 'Active' : 'Inactive') + " ")])], 1)];
      }
    }, {
      key: "created",
      fn: function (_ref6) {
        var value = _ref6.value;
        return [_c('div', [_vm._v(" " + _vm._s(_vm.formatDate(value)) + " ")]), _c('div', {
          staticClass: "text-xs italic text-gray-500"
        }, [_vm._v(" " + _vm._s(_vm.formatTime(value)) + " ")])];
      }
    }, {
      key: "modified",
      fn: function (_ref7) {
        var value = _ref7.value;
        return [_c('div', [_vm._v(" " + _vm._s(_vm.formatDate(value)) + " ")]), _c('div', {
          staticClass: "text-xs italic text-gray-500"
        }, [_vm._v(" " + _vm._s(_vm.formatTime(value)) + " ")])];
      }
    }, {
      key: "actions",
      fn: function (_ref8) {
        var row = _ref8.row;
        return [_c('router-link', {
          staticClass: "inline-block mx-auto",
          attrs: {
            "to": {
              path: ("vendor/edit/" + (row.id))
            },
            "title": "Edit"
          }
        }, [_c('EditFilled')], 1)];
      }
    }])
  }), Number(_vm.totalRows) ? _c('div', {
    staticClass: "flex justify-between pt-4 pl-3 pr-3 mt-1 mb-2 bg-white border-t border-gray-100"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "font-normal text-gray-500"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(Number(_vm.totalRows) >= _vm.perPage ? _vm.perPage : Number(_vm.totalRows)) + " "), _c('span', {
    staticClass: "font-normal text-gray-500"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    attrs: {
      "disabled": _vm.isLoading,
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    on: {
      "change": _vm.onClickPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }